import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {NomenclatureStorage, NomenclatureStorageSearchParams} from '@accounting/_common/models/nomenclature-storage.models';

export const CheckState = createAction(
    '[NomenclatureStorages] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: NomenclatureStorage[] } }>()
);

export const CheckStateSuccess = createAction(
    '[NomenclatureStorages] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: NomenclatureStorage[] } }>()
);

export const LoadList = createAction(
    '[NomenclatureStorages] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[NomenclatureStorages] Load List Success',
    props<{ payload: { items: NomenclatureStorage[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[NomenclatureStorages] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[NomenclatureStorages] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[NomenclatureStorages] Set Filter',
    props<{ payload: NomenclatureStorageSearchParams }>()
);

export const SetLoading = createAction(
    '[NomenclatureStorages] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[NomenclatureStorages] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[NomenclatureStorages] Update Item Success',
    props<{ payload: NomenclatureStorage }>()
);

export const DeleteItem = createAction(
    '[NomenclatureStorages] Delete Item',
    props<{ payload: NomenclatureStorage }>()
);

export const DeleteItemSuccess = createAction(
    '[NomenclatureStorages] Delete Item Success',
    props<{ payload: NomenclatureStorage }>()
);

export const DeleteItemFailure = createAction(
    '[NomenclatureStorages] Delete Item Failure',
    props<{ payload: NomenclatureStorage }>()
);

export const SetInitialState = createAction(
    '[NomenclatureStorages] Set Initial State'
);

export const UpdateNomenclatureStorageItem = createAction(
    '[NomenclatureStorages] Update NomenclatureStorage Item',
    props<{ payload: NomenclatureStorage }>()
);
